import { useState, useEffect } from 'react';

export interface PocketItem {
  gameId: string;
  folder: string;
  addedAt: number;
}

export const FOLDERS = ['출퇴근', '자기 전', '멍때리기', '두뇌'] as const;
export type FolderType = typeof FOLDERS[number];

const STORAGE_KEY = 'game-pocket';

export function usePocket() {
  const [pocket, setPocket] = useState<PocketItem[]>([]);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      try {
        setPocket(JSON.parse(stored));
      } catch (e) {
        console.error('Failed to parse pocket data', e);
      }
    }
  }, []);

  const savePocket = (newPocket: PocketItem[]) => {
    setPocket(newPocket);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(newPocket));
  };

  const addToPocket = (gameId: string, folder: FolderType) => {
    const exists = pocket.find(item => item.gameId === gameId);
    if (exists) {
      const updated = pocket.map(item =>
        item.gameId === gameId ? { ...item, folder } : item
      );
      savePocket(updated);
    } else {
      savePocket([...pocket, { gameId, folder, addedAt: Date.now() }]);
    }
  };

  const removeFromPocket = (gameId: string) => {
    savePocket(pocket.filter(item => item.gameId !== gameId));
  };

  const isInPocket = (gameId: string) => {
    return pocket.some(item => item.gameId === gameId);
  };

  const getGameFolder = (gameId: string) => {
    return pocket.find(item => item.gameId === gameId)?.folder;
  };

  return {
    pocket,
    addToPocket,
    removeFromPocket,
    isInPocket,
    getGameFolder
  };
}
